<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: 'MaterialdisposalLst/OurMaterial' }"
            >我的处置公告</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{ path: 'feedbackQualification', query: { id: typeId } }"
            >反馈看货申请列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>反馈看货申请</el-breadcrumb-item>
        </el-breadcrumb>
        <h4 class="account-card-title">反馈看货申请</h4>
      </div>
      <div class="title-little-subheading">处置公告要素</div>
      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞价开始时间:">
                <span>{{ ruleForm.bidStartTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="竞买资格审核:">
                <span>{{
                  ruleForm.enrollExamine == 1 ? '资格审核' : '无需资格审核'
                }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="title-little-subheading">与看货相关</div>
      <div class="form">
        <el-form :model="ruleForm" label-width="150px">
          <el-form-item label="现场看货：">
            {{
              ruleForm.inspectWhether == '0'
                ? '无需申请看货，按公告发布的看货要求看货'
                : '接受申请看货，在申请反馈中通知看货时间、地点、联系人等看货详情'
            }}
          </el-form-item>
          <el-form-item label="看货联系人及电话:" prop="inspectContName">
            <span>{{ ruleForm.inspectContName }} </span>
          </el-form-item>
          <el-form-item label="看货说明：">
            <span>
              {{ ruleForm.inspectReamrk }}
            </span>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="看货开始时间：">
                {{ ruleForm.inspectStartTime }}
              </el-form-item></el-col
            >
            <el-col :span="12">
              <el-form-item label="看货结束时间：">
                {{ ruleForm.inspectEndTime }}
              </el-form-item></el-col
            >
          </el-row>
          <el-form-item label="看货地点：">
            <div>
              {{ ruleForm.inspectAddress }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="title-little-subheading">看货申请信息</div>
      <div class="titlepen">
        <el-form :model="formself" ref="formself" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞买人:">
                <span>{{ formself.compName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请看货时间:">
                <span>{{ formself.inspectApplyTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请看货人数:">
                <span>{{ formself.inspectApplyNum }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="看货联系人:">
                <span>{{ formself.contName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机:">
                <span>{{ formself.contMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱:">
                <span>{{ formself.contEmail }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电话:">
                <span>{{ formself.contPhone }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他联系方式:">
                <span>{{ formself.contOtherWay }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="申请说明:">
            <span>{{ formself.inspectApplyRemark }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="title-little-subheading">申请反馈信息</div>
      <div class="form">
        <el-form
          :model="formAudit"
          ref="formAudit"
          label-width="150px"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人:" v-if="typequery == 1">
                <span>{{ formAudit.inspectFeedbackContName }}</span>
              </el-form-item>
              <el-form-item
                label="联系人:"
                v-else
                prop="inspectFeedbackContName"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input
                  v-model="formAudit.inspectFeedbackContName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式:" v-if="typequery == 1">
                <span>{{ formAudit.inspectFeedbackContMobile }}</span>
              </el-form-item>
              <el-form-item
                label="联系方式:"
                v-else
                prop="inspectFeedbackContMobile"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input
                  v-model="formAudit.inspectFeedbackContMobile"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="看货时间:" v-if="typequery == 1">
                <span>{{ formAudit.inspectFeedbackTime }}</span>
              </el-form-item>
              <el-form-item
                label="看货时间:"
                prop="inspectFeedbackTime"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                v-else
              >
                <el-date-picker
                  v-model="formAudit.inspectFeedbackTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  default-time="9:00:00"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="看货人数:" v-if="typequery == 1">
                <span>{{ formAudit.inspectFeedbackNum }}</span>
              </el-form-item>
              <el-form-item
                label="看货人数:"
                prop="inspectFeedbackNum"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                v-else
              >
                <template slot="label">
                  最多看货人数
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content">
                      最多看货人数99人
                    </template>
                    <i class="el-icon-question table-worming">&nbsp;</i>
                  </el-tooltip>
                  :
                </template>
                <el-input
                  v-model="formAudit.inspectFeedbackNum"
                  placeholder="请输入内容"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-digits-limit="[2, 0]"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="看货地点:" v-if="typequery == 1">
            <span>{{ formAudit.inspectFeedbackPlace }}</span>
          </el-form-item>
          <el-form-item
            label="看货地点:"
            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
            prop="inspectFeedbackPlace"
            v-else
          >
            <el-input
              v-model="formAudit.inspectFeedbackPlace"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="说明:">
            <span v-if="typequery == 1">{{
              formAudit.inspectFeedbackRemark
            }}</span>
            <el-input
              v-model="formAudit.inspectFeedbackRemark"
              placeholder="请填写看货联系人、联系方式和看货要求"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              v-else
            ></el-input>
          </el-form-item>
          <el-form-item label="附件:">
            <template slot="label">
              附件
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  可上传doc、docx、xls、xslx、pdf格式文件，最多3个文件，每个文件不超过5M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <div v-if="typequery == 1">
              <div
                v-for="(item, index) in formAudit.inspectFileList"
                :key="index"
              >
                <a
                  href="javascript:;"
                  @click="onDownload(item)"
                  class="attachment"
                >
                  {{ item.fileName }}
                </a>
              </div>
            </div>
            <on-price
              v-else
              :multiple="true"
              accept="*"
              :type="'primary'"
              @fileDataSingle="noticeFiles"
              :fileList="formAudit.noticeFiles"
            ></on-price>
          </el-form-item>
        </el-form>
      </div>

      <div class="page-index-footer">
        <el-button
          @click="submitForm('formAudit')"
          type="primary"
          v-if="typequery != 1"
          >确定</el-button
        >
        <el-button @click="down">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formAudit: {
        inspectFeedbackTime: '',
        inspectFeedbackNum: null,
        inspectFeedbackRemark: '',
        noticeFiles: [],
        inspectFeedbackPlace: '',
        inspectFeedbackContMobile: '',
        inspectFeedbackContName: ''
      },
      number: '0',
      formself: {},
      form: {
        auditRemark: ''
      },
      ruleForm: {
        title: '',
        code: '',
        bidStartTime: '',
        instructions: ''
      },
      tableData: [],
      multipleSelection: [],
      dialogTableVisible: false,
      choose: ''
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    },
    noticeID() {
      return this.$route.query.noticeID
    },
    typequery() {
      return this.$route.query.typequery
    }
  },
  created() {
    this.noticeGet()

    this.sellerInspectGet()
  },
  methods: {
    noticeFiles(val) {
      this.formAudit.noticeFiles = val
    },

    async sellerInspectGet() {
      let data = await this.$api.materialdisposal.sellerInspectGet({
        id: this.typeId
      })
      this.formself = data
      if (this.typequery == 1) {
        this.formAudit = data
      }
    },
    async noticeGet() {
      let data = await this.$api.materialdisposal.noticeGet({
        id: this.noticeID
      })
      this.ruleForm = data
    },
    async submitForm(formAudit) {
      this.$refs[formAudit].validate(valid => {
        if (valid) {
          this.feedback()
        } else {
          return false
        }
      })
    },
    async feedback() {
      let fileIdsinspectFeedback = ''
      if (this.formAudit.noticeFiles.length === 1) {
        fileIdsinspectFeedback = this.formAudit.noticeFiles[0].fileId.toString()
      } else {
        this.formAudit.noticeFiles.map((item, index) => {
          if (index === 0) {
            fileIdsinspectFeedback = item.fileId
          } else {
            fileIdsinspectFeedback = fileIdsinspectFeedback + ',' + item.fileId
          }
        })
      }
      let query = {
        inspectFeedbackTime: this.formAudit.inspectFeedbackTime,
        inspectFeedbackNum: this.formAudit.inspectFeedbackNum,
        inspectFeedbackRemark: this.formAudit.inspectFeedbackRemark,
        fileIdsinspectFeedback: fileIdsinspectFeedback,
        inspectFeedbackPlace: this.formAudit.inspectFeedbackPlace,
        inspectFeedbackContMobile: this.formAudit.inspectFeedbackContMobile,
        inspectFeedbackContName: this.formAudit.inspectFeedbackContName,
        id: this.typeId
      }
      let data = await this.$api.materialdisposal.feedback(query)
      if (data) {
        this.$message.success('提交成功')
        let query = {
          id: this.noticeID
        }
        this.$router.push({ name: 'feedbackQualification', query })
      }
    },
    async link(o) {
      let res = await this.$api.common.downloadFile(o.fileId)
      let blob = new Blob([res])
      let fileName = o.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    down() {
      this.$router.go(-1)
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.form {
  padding-right: 50px;
  padding-left: 70px;
}
.instructions {
  min-height: 120px;
  line-height: 20px;
  margin-left: 60px;
}
.titlepen {
  padding-left: 50px;
}
.titlepenleft {
  margin-left: 10px;
}
.titlepenright {
  float: right;
}
.down {
  margin-left: 500px;
  margin-bottom: 20px;
}
.table {
  margin-bottom: 20px;
}
</style>
